// 订阅我们管理
import http from "@/jslibs/axios/http";

// 订阅我们列表
export const list = (data) => http.get("/v1/cms/SubscribeUs", data);
